export default __webpack_public_path__ + "static/media/bg1.b44f17f3.jpeg";